import { ModerationService } from "./ModerationService";
export default ModerationService;
